import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface StatusBarChartProps {
  data: any[];
}

const StatusBarChart: React.FC<StatusBarChartProps> = ({ data }) => {
  // Transform data for bar chart
  const chartData = data.map(item => ({
    source: item.source,
    published: item.status_counts.published || 0,
    unpublished: item.status_counts.unpublished || 0,
    in_progress: item.status_counts.in_progress || 0,
    invalid_file: item.status_counts.invalid_file || 0,
    failed: item.status_counts.failed || 0,
    filename_invalid: item.status_counts.filename_invalid || 0
  }));

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`Source: ${label}`}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ color: entry.color }}>
              {`${entry.dataKey}: ${entry.value}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3>Status Distribution by Source</h3>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="source" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="published" stackId="a" fill="#00C49F" name="Published" />
          <Bar dataKey="unpublished" stackId="a" fill="#FF8042" name="Unpublished" />
          <Bar dataKey="in_progress" stackId="a" fill="#FFBB28" name="In Progress" />
          <Bar dataKey="invalid_file" stackId="a" fill="#8884D8" name="Invalid File" />
          <Bar dataKey="failed" stackId="a" fill="#FF0000" name="Failed" />
          <Bar dataKey="filename_invalid" stackId="a" fill="#FFA500" name="Filename Invalid" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StatusBarChart;
